import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcSearchH72(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "72",
    height: "72",
    fill: "none",
    viewBox: "0 0 72 72",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M28.5 6C40.926 6 51 16.074 51 28.5c0 5.403-1.905 10.36-5.08 14.24l15.67 15.67a2.25 2.25 0 0 1-3.18 3.18L42.74 45.92A22.4 22.4 0 0 1 28.5 51C16.074 51 6 40.926 6 28.5S16.074 6 28.5 6m0 4.5c-9.941 0-18 8.059-18 18s8.059 18 18 18 18-8.059 18-18-8.059-18-18-18",
    clipRule: "evenodd"
  }));
}
var IcSearchH72 = createNolIcon(/*#__PURE__*/forwardRef(SvgIcSearchH72));

export { IcSearchH72 as I };
